var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStonks({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1534 0.64676L9.66291 8.93016C9.4871 9.10169 9.37436 9.3207 9.34949 9.53902C9.32463 9.75734 9.38968 9.95708 9.53033 10.0943C9.67098 10.2315 9.87572 10.295 10.0995 10.2707C10.3233 10.2465 10.5478 10.1365 10.7236 9.96495L19.2141 1.68155C19.3899 1.51002 19.5026 1.29101 19.5275 1.07269C19.5523 0.854374 19.4873 0.654634 19.3466 0.517413C19.206 0.380191 19.0013 0.316728 18.7775 0.340985C18.5537 0.365243 18.3292 0.475233 18.1534 0.64676Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1534 6.50401L0.662913 11.8606C0.487097 12.0321 0.374357 12.2511 0.349493 12.4694C0.324629 12.6878 0.389678 12.8875 0.53033 13.0247C0.670982 13.1619 0.875716 13.2254 1.09949 13.2011C1.32327 13.1769 1.54776 13.0669 1.72357 12.8954L7.21406 7.5388C7.38987 7.36727 7.50261 7.14826 7.52748 6.92994C7.55234 6.71162 7.48729 6.51188 7.34664 6.37466C7.20599 6.23744 7.00125 6.17398 6.77748 6.19824C6.5537 6.22249 6.32921 6.33248 6.1534 6.50401Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2139 8.93025L7.72346 6.5005C7.54764 6.32898 7.32316 6.21899 7.09938 6.19473C6.8756 6.17047 6.67087 6.23393 6.53022 6.37116C6.38956 6.50838 6.32452 6.70812 6.34938 6.92644C6.37424 7.14475 6.48698 7.36377 6.6628 7.53529L9.15329 9.96504C9.3291 10.1366 9.55359 10.2466 9.77737 10.2708C10.0011 10.2951 10.2059 10.2316 10.3465 10.0944C10.4872 9.95716 10.5522 9.75742 10.5274 9.53911C10.5025 9.32079 10.3898 9.10177 10.2139 8.93025Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 19.2683C0 18.8642 0.319561 18.5366 0.71376 18.5366H19.2862C19.6804 18.5366 20 18.8642 20 19.2683C20 19.6724 19.6804 20 19.2862 20H0.71376C0.319561 20 0 19.6724 0 19.2683Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7138 0C13.3196 0 13 0.327597 13 0.731707C13 1.13582 13.3196 1.46341 13.7138 1.46341H18.5L18.5 6.13292C18.5 6.5175 18.8358 6.82927 19.25 6.82927C19.6642 6.82927 20 6.5175 20 6.13292L20 0.731776C20 0.731753 20 0.73173 20 0.731707V0.696352C20 0.506627 19.9183 0.334623 19.7857 0.20903C19.657 0.0797244 19.4807 0 19.2862 0H19.25H13.7138Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStonks);
export default __webpack_public_path__ + "static/media/stonks.05fdc1e2352854305795966638a02794.svg";
export { ForwardRef as ReactComponent };